import React, { memo } from 'react';
import s from './StateWrapper.scss';

// We created this component to carry out the same structure on multiple pages
// To reduce the dom and css redundency
const StateWrapper = ({ children }) => (
  <div className={`${s.stateWrap}`}>{children}</div>
);

export default memo(StateWrapper);
